export const reviewQuestionsThreatOrWeekness = [{
    key: 'review_question_text',
    type: 'textarea',
    value: '',
    valid: false,
    elementConfig: {
        name: 'review_question_text',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/ReviewQuestionsThreatOrWeekness/formData.js